import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const removeFirmwareAPI = async (id, filePath, t, successText) => {
  await axios({
    url: `/api/v2/admin-utility/firmware/delete`,
    method: "DELETE",
    data: {
      id: id,
      file_path: filePath
    }
  });
  successHandling(t, successText);
  return true;
};
